import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDiagramTree12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconDiagramTree12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.5 2a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 1a1.5 1.5 0 1 0-1.415-2H7.5A1.5 1.5 0 0 0 6 2.5v3H5V3a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6.5h1v3A1.5 1.5 0 0 0 7.5 11h.585a1.5 1.5 0 1 0 0-1H7.5a.5.5 0 0 1-.5-.5v-3h1.085a1.5 1.5 0 1 0 0-1H7v-3a.5.5 0 0 1 .5-.5h.585A1.5 1.5 0 0 0 9.5 3M2 3h2v6H2zm8 3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDiagramTree12);
